import { useState } from "react";
import { CSVLink } from "react-csv";
import BorderAllIcon from "@mui/icons-material/BorderAll";
import InventoryIcon from "@mui/icons-material/Inventory";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from "moment";
import axios from "axios";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditList from "./EditList";
import { Modal } from "@mui/material";

export default function IndvList({
  l,
  newcsvData,
  refreshAssets,
  archive,
  assetLocations,
}) {
  console.log(l);
  const url = process.env.REACT_APP_URL;
  const [showCheckout, setShowCheckout] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const handleCheckIns = async (assetArr) => {
    for (let a = 0; a < assetArr.length; a++) {
      const reqBody = {
        currentUser: parseInt(localStorage.getItem("userId")),
        currentUsername: localStorage.getItem("username"),
        assetId: assetArr[a].assetId,
        locationId: 4,
        assetName: assetArr[a].assetName,
      };

      await axios
        .post(`${url}/assets/check-in`, reqBody)
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    }

    let archiveBody = {
      listName: l.name,
      listId: l.listId,
      currentUser: parseInt(localStorage.getItem("userId")),
      currentUsername: localStorage.getItem("username"),
    };

    await axios
      .post(`${url}/assets/archive-list`, archiveBody)
      .then((res) => {
        refreshAssets();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <tr>
        <td>{l.listId}</td>
        <td>{l.name}</td>
        <td>{moment(l.createdAt).format("HH:mm DD/MM/YY")}</td>
        <td>
          <CSVLink
            data={newcsvData}
            filename={`${l.name}-${moment().format("DD/MM/YY")}.csv`}
          >
            <BorderAllIcon fontSize="large" color="success" />
          </CSVLink>
        </td>
        {!archive ? (
          <>
            <td>
              <Tooltip title="Check in assets & archive list">
                <IconButton>
                  <InventoryIcon
                    color="primary"
                    onClick={() => setShowCheckout(!showCheckout)}
                  />{" "}
                </IconButton>
              </Tooltip>
              {showCheckout ? (
                <span>
                  <Tooltip title="Yes, archive and check in list.">
                    <IconButton>
                      <CheckCircleIcon
                        color="success"
                        onClick={() => {
                          handleCheckIns(l.assets);
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="No, go back">
                    <IconButton>
                      <CancelIcon
                        color="error"
                        onClick={() => setShowCheckout(false)}
                      />{" "}
                    </IconButton>
                  </Tooltip>
                </span>
              ) : null}
            </td>
            <td>
              <Tooltip title="Edit List">
                <IconButton onClick={() => setShowEdit(true)}>
                  <EditIcon color="warning" />
                </IconButton>
              </Tooltip>
            </td>
          </>
        ) : null}
      </tr>
      {/* MODALS */}
      <Modal open={showEdit}>
        <EditList
          handleClose={setShowEdit}
          refreshAssets={refreshAssets}
          listName={l.name}
          listId={l.listId}
          listAssets={l.assets}
        />
      </Modal>
    </>
  );
}
